import { getGaAnonymousId, getBrowserName, getDeviceType } from './src-utils-app-utils.js';
import { getPreChatInfoFromLocalStorage, getRestId } from './src-utils-session-storage-utils.js';
import { isStudioPage } from './src-utils-chat-page-utils.js';

const getRoutingAttributes = (customData, caseData, queueId, queueName, userData) => {
  const customerDatafromLocalStorage = getPreChatInfoFromLocalStorage();
  const updatedCustomerData = {
    firstName: userData?.firstName || "",
    lastName: userData?.lastName || "",
    email: userData?.email || ""
  };
  if (!updatedCustomerData.email || updatedCustomerData.email.length === 0) {
    updatedCustomerData.email = customerDatafromLocalStorage.email || "";
  }
  if (!updatedCustomerData.firstName || updatedCustomerData.firstName.length === 0) {
    updatedCustomerData.firstName = customerDatafromLocalStorage.firstName || "";
  }
  if (!updatedCustomerData.lastName || updatedCustomerData.lastName.length === 0) {
    updatedCustomerData.lastName = customerDatafromLocalStorage.lastName || "";
  }
  const subject = customData.chatbotIdentifier ? `Chatbot - ${caseData.pageName}` : caseData.subject || "Chatbot - Home Page";
  const description = customData.chatbotIdentifier ? `${caseData.pageName} - Chatbot Case` : caseData.description || "Help Center - Chatbot Case";
  const requestData = {
    _firstName: updatedCustomerData?.firstName,
    _lastName: updatedCustomerData?.lastName,
    _email: updatedCustomerData?.email,
    userShopperId: customData.userShopperId || "",
    chatbotIdentifier: customData.chatbotIdentifier || "",
    chatLocale: caseData.chatLocale || "",
    brand: caseData.brand || "VP",
    banner: caseData.banner || "VP",
    priority: queueName === "checkout" ? "High" : caseData.priority || "Medium",
    pageName: caseData.pageName || "Home Page:Help Center",
    pageURL: window?.location.href || "",
    category: caseData.category || "Others",
    subCategory: caseData.subCategory || "Others",
    caseOrigin: `${caseData.caseOrigin}${customData.chatbotIdentifier ? "-VA" : ""}`,
    status: caseData.status || "In Progress",
    pageSection: caseData.pageSection || "Home Page",
    pageStage: caseData.pageStage || "Customer Care",
    subject,
    description,
    pagePath: window?.location.pathname || "",
    queueId: queueId || "",
    BrowserPlatform: navigator.platform || "",
    nrLogKey: getRestId() || "",
    gaAnonymousId: getGaAnonymousId() || "",
    referrerURL: document.referrer || "",
    orderNumber: customData.orderNumber || "",
    selectedProductIds: customData.selectedProductIds ? customData.selectedProductIds.slice(0, 3).join(",") : "",
    device_type: getDeviceType() || "",
    browser: getBrowserName() || "",
    chatbotContactReason: customData.chatbotContactReason || ""
  };
  if (isStudioPage()) {
    requestData.liveDesignURL = customData.studioDesignLink || "";
  }
  return requestData;
};

export { getRoutingAttributes };
//# sourceMappingURL=src-utils-miaw-start-chat-utils.js.map
